<template>
    <div class="auth">
        <v-card variant="outlined" width="400" class="auth__card">
            <v-card-title class="auth__card__title">
                English Conversation Transcriber
            </v-card-title>
            <v-card-text class="auth__card__text">
                <v-row>
                    <v-col>
                        <v-btn class="auth__card__text__btn" @click="authWithGoogle" variant="outlined">
                        <v-icon class="auth__card__text__btn__icon">mdi-google</v-icon>
                            Sign in with Google
                        </v-btn>
                    </v-col>
                    <v-col>
                        <v-btn class="auth__card__text__btn" @click="authWithGoogle" variant="outlined">
                            <v-icon class="auth__card__text__btn__icon">mdi-account-plus</v-icon>
                            Sign up with Google
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { auth } from '@/plugins/firebase';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { Profile } from '@/models/models'


export default defineComponent({
    name: 'HomeView',
    setup() {
        const router = useRouter();
        const store = useStore();
        const profile = ref<Profile |null>(null);

        const authWithGoogle = async () => {
            const provider = new GoogleAuthProvider();
            try {
                const result = await signInWithPopup(auth, provider);
                const user = result.user;

                await store.dispatch('profile/fetchProfile', user.uid);
                profile.value = store.getters['profile/profile'];

                if (!profile.value) {
                    profile.value = {
                        name: user.displayName,
                        email: user.email,
                        payment_info: null,
                        membership_plan: 'basic',
                        last_uploaded_date: null,
                        transcribed_count_per_day: 0,
                        suggested_count_per_day: 0,
                        uploaded_files_count_per_day: 0,
                        created_at: new Date(),
                    }
                    await store.dispatch('profile/createProfile', { uid: user.uid, profile: profile.value });
                } 
                router.push('/');
            } catch (error) {
                console.error('Error signing up with Google:', error);
            }
        }

        return {
            authWithGoogle,
        }
    }
});
</script>

<style lang="scss" scoped>
@import '@/assets/sass/size.scss';

.auth {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f5f5f5;
    &__card {
        &__title {
            margin-bottom: 30px;
            font-weight: bold;
        }
        &__text {
            &__btn {
                margin-bottom: 5px;
                &__icon {
                    margin: 10px;
                }
            }
        }
    }
}
</style>
